import React from 'react';
import '../../css/styles.css';
import '../../css/pages.css';
import '../../js/code.js';

//const Landing = () => {
class Landing extends React.Component {  
    //return (
render() {
  return (
      <div className="landing">
	  	  <article className="slide" style={{marginTop: 110}}>
		    Welcome
		  </article>
		  <article className="slide" style={{marginTop: 10}}>
		    To my quiz
		  </article>
		  <article className="slide" style={{marginTop: 10}}>
		    Play now...
		  </article>
	  </div>
    );
  };
};

export default Landing;


// WEBPACK FOOTER //
// ./src/components/layout/landing.jsx